export default {
  'surrey_wheels.png': require('./surrey_wheels.png'),
  // 'grizzly.png': require('./grizzly.png'),
}



// WEBPACK FOOTER //
// ./src/assets/logos/index.js